import {IEmployeesState, initialEmployeesState} from '@app/core/store/state/employees.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {EEmployeesActions, EmployeesActions} from '@app/core/store/actions/employees.actions';

export const employeesReducers = (
	state = initialEmployeesState,
	action: EmployeesActions | ErrorActions,
): IEmployeesState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
			};
		}
		case EEmployeesActions.GetUsers: {
			return {
				...state,
				isLoading: true,
				shouldReloadUsers: false,
			};
		}
		case EEmployeesActions.GetUsersSuccess: {
			return {
				...state,
				isLoading: false,
				users: action.users,
			};
		}
		case EEmployeesActions.GetUser: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EEmployeesActions.GetUserSuccess: {
			action.user.groups = action.user.groups.map(g => {
				const foundHourSalary = action.user.hour_salaries?.find(h => h.group_id === g.id);
				if (foundHourSalary) {
					g.customHourSalary = foundHourSalary.hour_salary;
				}

				return g;
			});

			return {
				...state,
				isLoading: false,
				editingUser: action.user,
			};
		}
		case EEmployeesActions.PostUser: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EEmployeesActions.PostUserSuccess: {
			return {
				...state,
				isLoading: false,
				shouldReloadUsers: true,
			};
		}
		case EEmployeesActions.PatchUser: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EEmployeesActions.PatchUserSuccess: {
			return {
				...state,
				isLoading: false,
				shouldReloadUsers: true,
			};
		}
		case EEmployeesActions.PatchProfile: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EEmployeesActions.PatchProfileSuccess: {
			return {
				...state,
				isLoading: false,
				shouldReloadUsers: true,
			};
		}
		case EEmployeesActions.DeleteUser: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EEmployeesActions.DeleteUserSuccess: {
			return {
				...state,
				isLoading: false,
				shouldReloadUsers: true,
			};
		}
		case EEmployeesActions.DeactivateUser: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EEmployeesActions.DeactivateUserSuccess: {
			return {
				...state,
				isLoading: false,
				shouldReloadUsers: true,
			};
		}
		case EEmployeesActions.ActivateUser: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EEmployeesActions.ActivateUserSuccess: {
			return {
				...state,
				isLoading: false,
				shouldReloadUsers: true,
			};
		}
		case EEmployeesActions.SendActivationMail: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EEmployeesActions.SendActivationMailSuccess: {
			return {
				...state,
				isLoading: false,
			};
		}
		case EEmployeesActions.SetEditingUser: {
			return {
				...state,
				editingUser: action.user,
				salaryCalculation: action.user ? state.salaryCalculation : undefined,
				salaryCalculationMonth: action.user ? state.salaryCalculationMonth : undefined,
			};
		}
		case EEmployeesActions.GetGroups: {
			return {
				...state,
				isLoading: true,
				shouldReloadGroups: false,
			};
		}
		case EEmployeesActions.GetGroupsSuccess: {
			return {
				...state,
				isLoading: false,
				groups: action.groups,
			};
		}
		case EEmployeesActions.GetAllGroups: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EEmployeesActions.GetAllGroupsSuccess: {
			return {
				...state,
				isLoading: false,
				allGroups: action.groups,
			};
		}
		case EEmployeesActions.GetGroup: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EEmployeesActions.GetGroupSuccess: {
			return {
				...state,
				isLoading: false,
			};
		}
		case EEmployeesActions.PostGroup: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EEmployeesActions.PostGroupSuccess: {
			return {
				...state,
				isLoading: false,
				shouldReloadGroups: true,
			};
		}
		case EEmployeesActions.PatchGroup: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EEmployeesActions.PatchGroupSuccess: {
			return {
				...state,
				isLoading: false,
				shouldReloadGroups: true,
			};
		}
		case EEmployeesActions.DeleteGroup: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EEmployeesActions.DeleteGroupSuccess: {
			return {
				...state,
				isLoading: false,
				shouldReloadGroups: true,
			};
		}
		case EEmployeesActions.SetEditingGroup: {
			return {
				...state,
				editingGroup: action.group,
			};
		}
		case EEmployeesActions.SetIsSeeingEmployees: {
			return {
				...state,
				isSeeingEmployees: action.isSeeingEmployees,
			};
		}
		case EEmployeesActions.SetShowAllUsers: {
			return {
				...state,
				showAllUsers: action.showAllUsers,
			};
		}
		case EEmployeesActions.SetDepartmentsFilter: {
			return {
				...state,
				departmentsFilter: action.filter,
			};
		}
		case EEmployeesActions.SetShouldReloadUsers: {
			return {
				...state,
				shouldReloadUsers: true,
			};
		}
		case EEmployeesActions.SetShouldReloadGroups: {
			return {
				...state,
				shouldReloadGroups: true,
			};
		}
		case EEmployeesActions.SetEmployeeSearchQuery: {
			return {
				...state,
				searchQuery: action.searchQuery,
			};
		}
		case EEmployeesActions.GetInformationForCreatingUser: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EEmployeesActions.GetInformationForCreatingUserSuccess: {
			return {
				...state,
				isLoading: false,
				departments: action.departments,
			};
		}
		case EEmployeesActions.SetDepartments: {
			return {
				...state,
				isLoading: false,
				departments: action.departments,
			};
		}
		case EEmployeesActions.GetSocialSecurityNumber: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EEmployeesActions.GetSocialSecurityNumberSuccess: {
			return {
				...state,
				isLoading: false,
				socialSecurityNumber: action.socialSecurityNumber,
			};
		}
		case EEmployeesActions.SetSocialSecurityNumber: {
			return {
				...state,
				socialSecurityNumber: action.socialSecurityNumber,
			};
		}

		case EEmployeesActions.GetEmployeeSupplementalSalariesSuccess: {
			return {
				...state,
				isLoading: false,
				supplementalSalaries: action.supplementalSalaries,
				supplementalSalariesPagination: action.pagination,
			};
		}
		case EEmployeesActions.GetEmployeeSupplementalSalariesWithGroupsSuccess: {
			return {
				...state,
				isLoading: false,
				autoSupplementalSalaries: action.supplementalSalaries.filter(supp => state.supplementalSalaries.map(s => s.id).indexOf(supp.id) < 0),
			};
		}

		case EEmployeesActions.RemoveGroupForSupplemetalSalary: {
			const currentGroups = state.editingUser.groups.map(g => g.id);

			return {
				...state,
				supplementalSalaries: state.supplementalSalaries.filter(supp => supp.groups.filter(group => currentGroups.includes(group.id)).length > 0),
				autoSupplementalSalaries: state.autoSupplementalSalaries.filter(supp => supp.groups.filter(group => currentGroups.includes(group.id)).length > 0),
			};
		}
		case EEmployeesActions.ClearAutoSupplementalSalaries: {
			return {
				...state,
				autoSupplementalSalaries: [],
			};
		}
		case EEmployeesActions.ClearSupplementalSalaries: {
			return {
				...state,
				supplementalSalaries: [],
			};
		}
		case EEmployeesActions.GetEmployeeSalaryTotalsCalculation: {
			return {
				...state,
				isSalaryCalculationLoading: true,
			};
		}

		case EEmployeesActions.GetEmployeeSalaryTotalsCalculationSuccess: {
			return {
				...state,
				isSalaryCalculationLoading: false,
				salaryCalculation: action.salaryTotalsCalc,
				salaryCalculationMonth: action.month,
			};
		}
		default:
			return state;
	}
};
